/**
 * SpectrumScrollFeature - 4屏滚动联动切换
 */
var SpectrumScroll = {
  activeIndex: 0,
  totalSlides: 4,

  init: function () {
    var self = this;
    window.addEventListener('scroll', function () {
      self.handleScroll();
    }, { passive: true });

    // Initial check
    this.handleScroll();
  },

  handleScroll: function () {
    var container = document.getElementById('spectrumScroll');
    if (!container) return;

    var rect = container.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var scrollableDistance = rect.height - windowHeight;
    var currentScroll = -rect.top;

    var newIndex;
    if (currentScroll < 0) {
      newIndex = 0;
    } else if (currentScroll >= scrollableDistance) {
      newIndex = this.totalSlides - 1;
    } else {
      var progress = currentScroll / scrollableDistance;
      newIndex = Math.min(Math.floor(progress * this.totalSlides), this.totalSlides - 1);
    }

    if (newIndex !== this.activeIndex) {
      this.setActive(newIndex);
    }
  },

  setActive: function (idx) {
    this.activeIndex = idx;

    // Update text slides
    for (var i = 0; i < this.totalSlides; i++) {
      var textEl = document.getElementById('specText' + i);
      if (!textEl) continue;

      textEl.classList.remove('opacity-100', 'translate-y-0', 'z-10', 'opacity-0', 'translate-y-12', '-translate-y-12', '-z-10', 'pointer-events-none', 'z-0');

      if (idx === i) {
        textEl.classList.add('opacity-100', 'translate-y-0', 'pointer-events-auto');
        textEl.style.zIndex = '10';
      } else if (idx > i) {
        textEl.classList.add('opacity-0', '-translate-y-12', 'pointer-events-none');
        textEl.style.zIndex = '-10';
      } else {
        textEl.classList.add('opacity-0', 'translate-y-12', 'pointer-events-none');
        textEl.style.zIndex = '-10';
      }
    }

    // Update images
    for (var j = 0; j < this.totalSlides; j++) {
      var imgEl = document.getElementById('specImg' + j);
      if (!imgEl) continue;

      imgEl.classList.remove('opacity-100', 'scale-100', 'z-10', 'opacity-0', 'scale-110', 'z-0');
      if (idx === j) {
        imgEl.classList.add('opacity-100', 'scale-100');
        imgEl.style.zIndex = '10';
      } else {
        imgEl.classList.add('opacity-0', 'scale-110');
        imgEl.style.zIndex = '0';
      }
    }

    // Update dots
    for (var k = 0; k < this.totalSlides; k++) {
      var dot = document.getElementById('specDot' + k);
      if (!dot) continue;
      if (idx === k) {
        dot.classList.remove('w-2', 'bg-white/50');
        dot.classList.add('w-6', 'bg-white');
      } else {
        dot.classList.remove('w-6', 'bg-white');
        dot.classList.add('w-2', 'bg-white/50');
      }
    }
  }
};
